import checkPermissions from './checkPermissions';

import { OFFERS_SOURCE } from '../constants/common';

export default (offers, source = OFFERS_SOURCE.LOCAL, permissionsData = {}) => {
  let preparedOffers = [];

  switch (source) {
    case OFFERS_SOURCE.REMOTE: {
      if (offers) {
        preparedOffers = offers.map(({ disableDimming, ...restOfferData }) => ({
          offerData: restOfferData,
          offerMeta: {
            behavior: [],
            disableDimming,
          },
        }));
      } else {
        preparedOffers = [];
      }
      break;
    }

    case OFFERS_SOURCE.LOCAL:
    default: {
      const { auth } = permissionsData;

      preparedOffers = offers.reduce((newOffers, offer) => {
        if (checkPermissions(offer.permissions, auth.data)) {
          return newOffers.concat({
            offerData: {
              buttonLink: offer.link.href,
              mobileButtonLink: offer.link.mobileHref,
              buttonText: offer.footerCaption,
              description: offer.text,
              title: offer.link.title,
              icon: offer.backgroundImageType === 'icon' ? offer.backgroundImage : '',
              image: offer.backgroundImageType === 'cover' ? offer.backgroundImage : '',
              name: offer.name,
              id: offer.key,
              specificLocators: offer.specificLocators,
            },
            offerMeta: {
              cardColor: offer.backgroundColor,
              titleColor: offer.titleColor,
              textColor: offer.textColor,
              footerTextColor: offer.footerColor,
              isBig: typeof offer.isBig !== 'undefined' ? offer.isBig : false,
              behavior: offer.link.behavior,
              behaviorData: offer.behaviorData,
              disableDimming: offer.disableDimming,
              metricsKM: offer.metricsKM,
            },
          });
        }

        return newOffers;
      }, []);
      break;
    }
  }

  return preparedOffers;
};
